import { recordInformation } from "components/DetailPage/RecordInformation";
import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import React, { useState } from "react";
import { uploadFileToCoreApi } from "utilities/fileUploadUtils";
import { contactToFormState, ContactFormState } from "shared/utils/fieldsHelper/contactFields";
import { contactMainSection } from "../sections/main";
import { otherDetailSection } from "../sections/otherDetailSection";
import { passportSection } from "../sections/passportSection";
import { socialsSection } from "../sections/socialsSection";

interface ContactDetailSectionProps {
  contact: server.dto.Contact
}

export const ContactDetailSection = (props: ContactDetailSectionProps) => {
  const [contact, setContact] = useState<server.dto.Contact>(props.contact);
  const [formState, setFormState] = useState<ContactFormState>(contactToFormState(contact, serverReference));
  const [tags, setTags] = useState<server.dto.TagSmall[]>(contact.tags);
  const [profileImageUrl, setProfileImageUrl] = useState<string | undefined>(contact.profileImageUrl);
  const [error, setError] = useState<string | undefined>();

  const uploadAvatar = async (file: File) => {
    const resp = await uploadFileToCoreApi(
      window.CoreApi.Contact.SetProfileImage,
      window.CoreApi.Contact.SetProfileImage.absoluteUrl(),
      {
        file,
        contactId: contact.contactId
      },
      {
        onUploadProgress: (_: ProgressEvent) => { },
        fileType: "image"
      });
    if (resp.data.hasErrors) {
      setError("Could not upload image");
      return;
    }
    setProfileImageUrl(resp.data.data.downloadUrl);
  }

  const onValueChanged = async (key: string, value: any) => {
    if (key === "name") {
      const [firstName, insertion, lastName] = value as string[];
      setFormState(prevState => ({
        ...prevState,
        firstName,
        insertion,
        lastName
      }));
    } else if (key === "department") {
      setFormState(prevState => ({
        ...prevState,
        department: value
      }));
    } else if (key === "status") {
      setFormState(prevState => ({
        ...prevState,
        status: value
      }));
    } else if (key === "tags") {
      setTags(value);
    } else if (key === "owner") {
      setFormState(prevState => ({
        ...prevState,
        owner: value
      }));
    } else if (key === "emailAddresses") {
      setFormState(prevState => ({
        ...prevState,
        emailAddresses: value[0],
        isEmailBlacklisted: value[1]
      }));
    } else if (key === "mobileNumbers") {
      setFormState(prevState => ({
        ...prevState,
        mobileNumbers: value
      }));
    } else if (key === "gender") {
      setFormState(prevState => ({
        ...prevState,
        gender: value
      }));
    } else if (key === "position") {
      setFormState(prevState => ({
        ...prevState,
        position: value
      }));
    } else if (key === "department") {
      setFormState(prevState => ({
        ...prevState,
        department: value
      }));
    } else if (key === "language") {
      setFormState(prevState => ({
        ...prevState,
        culture: value
      }));
    } else if (key === "landline") {
      setFormState(prevState => ({
        ...prevState,
        landlineNumbers: value
      }));
    } else if (key === "salutation") {
      setFormState(prevState => ({
        ...prevState,
        salutation: value
      }));
    } else if (key === "attn") {
      setFormState(prevState => ({
        ...prevState,
        attn: value
      }));
    } else if (key === "homeAddress") {
      setFormState(prevState => ({
        ...prevState,
        homeAddress: {
          ...value
        }
      }));
    } else if (key === "twitter") {
      setFormState(prevState => ({
        ...prevState,
        twitter: value
      }));
    } else if (key === "website") {
      setFormState(prevState => ({
        ...prevState,
        website: value
      }));
    } else if (key === "facebook") {
      setFormState(prevState => ({
        ...prevState,
        facebook: value
      }));
    } else if (key === "networkPath") {
      setFormState(prevState => ({
        ...prevState,
        networkPath: value
      }));
    } else if (key === "socialSecurity") {
      setFormState(prevState => ({
        ...prevState,
        socialSecurity: value
      }));
    } else if (key === "birthdate") {
      setFormState(prevState => ({
        ...prevState,
        birthdate: value ? value.toDate() : null
      }));
    } else if (key === "birthplace") {
      setFormState(prevState => ({
        ...prevState,
        birthplace: value
      }));
    } else if (key === "maritalStatus") {
      setFormState(prevState => ({
        ...prevState,
        maritalStatus: value
      }));
    } else if (key === "additionalInformation") {
      setFormState(prevState => ({
        ...prevState,
        additionalInformation: value
      }));
    } else if (key === "nationality") {
      setFormState(prevState => ({
        ...prevState,
        nationality: value
      }));
    } else if (key === "passportName") {
      setFormState(prevState => ({
        ...prevState,
        passportName: value
      }));
    } else if (key === "passportNumber") {
      setFormState(prevState => ({
        ...prevState,
        passportNumber: value
      }));
    } else if (key === "passportIssued") {
      setFormState(prevState => ({
        ...prevState,
        passportIssued: value ? value.toDate() : null
      }));
    } else if (key === "passportExpiration") {
      setFormState(prevState => ({
        ...prevState,
        passportExpiration: value ? value.toDate() : null
      }));
    }
    else {
      console.warn(`Unhandled key in ContactDetailSection: ${key}`);
      return;
    }
  }

  const onSuccessfulUpdate = async () => {
    const result = await window.CoreApi.Contact.GetSidePanelData(contact.contactId);

    setContact(result.data.data.contact);
    setFormState(contactToFormState(result.data.data.contact, serverReference));
  }

  return <DetailSectionTemplate
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={onSuccessfulUpdate}
    isInPageEditable={contact.permissions.canModify}
    sections={[
      contactMainSection(contact, formState, tags, profileImageUrl, error, uploadAvatar),
      socialsSection(contact, formState),
      otherDetailSection(contact, formState),
      passportSection(contact, formState),
      recordInformation(
        contact.createdUtc,
        contact.createdUser,
        contact.lastModifiedUtc,
        contact.lastModifiedUser),
    ]}
  />
}